import * as yup from "yup";

export const addMobileCombustionValidation = yup.object({
  facility: yup.string().required("Facility is required"),
  month: yup.string().required("Month is required"),
  year: yup.string().required("Year is required"),
  calculationMethod: yup.string().required("Calculation method is required"),
});
